import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";

import {
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

type HeaderRow = {
  key: string;
  width?: number;
  widthPercent?: number;
};

type TableRowType = Record<string, string | undefined>;
interface GenericTableProps {
  headers: HeaderRow[];
  rows: TableRowType[] | undefined;
  hideEmptyColumns?: boolean;
}

export default function PrintTable({
  headers,
  rows,
  hideEmptyColumns = false,
}: GenericTableProps) {
  const { t } = useTranslation();
  if (!rows?.length) return null;
  const visibleHeaders = hideEmptyColumns
    ? headers.filter(({ key }) =>
        rows?.some((row) => {
          const value = row[key]?.trim();
          return value !== undefined && value !== "" && value !== "-";
        }),
      )
    : headers;

  return (
    <div className="overflow-hidden rounded-lg border border-gray-200">
      <table className="w-full table-fixed caption-bottom text-sm">
        <TableHeader>
          <TableRow className="bg-transparent hover:bg-transparent divide-x divide-gray-200 border-b-gray-200">
            {visibleHeaders.map(({ key, width, widthPercent }, index) => (
              <TableHead
                className={cn(
                  index == 0 && "first:rounded-l-md",
                  "h-auto py-1 pl-2 pr-2 text-black text-center whitespace-normal break-words",
                  width && `w-${width}`,
                )}
                key={key}
                style={widthPercent ? { width: `${widthPercent}%` } : undefined}
              >
                {t(key)}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {!!rows &&
            rows.map((row, index) => (
              <TableRow
                key={index}
                className="bg-transparent hover:bg-transparent divide-x divide-gray-200"
              >
                {visibleHeaders.map(({ key }) => (
                  <TableCell
                    className="break-words whitespace-normal text-center"
                    key={key}
                  >
                    {row[key] || "-"}
                  </TableCell>
                ))}
              </TableRow>
            ))}
        </TableBody>
      </table>
    </div>
  );
}
